export default IconTrendingDown2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-trending-down-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 6h5l7 10h6" />
  <path d="M18 19l3 -3l-3 -3" />
</svg>`;